import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import { useDispatch } from "react-redux";
import TableRow from "@mui/material/TableRow";
import {
  Box,
  Card,
  Grid,
  IconButton,
  TableFooter,
  TablePagination,
  useTheme,
  Chip,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  TextField,
  styled,
  FormHelperText,
  Button,
  // DialogActions,
  CircularProgress,
  Autocomplete,
  InputAdornment,
  // Select,
  // MenuItem,
  FormControlLabel,
  Checkbox,
  FormControl,
  Pagination,
} from "@mui/material";

import {
  CustomTableContainer,
  CustomTableHead,
  TableContentFont,
  // TableContentVendorFont,
  TableHeaderFont,
} from "../../../styles/tableContent.style";
import {
  KeyboardArrowLeft,
  KeyboardArrowRight,
  RemoveRedEye,
} from "@mui/icons-material";
import PropTypes from "prop-types";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import {
  // ButtonLink,
  DisplayText,
} from "../../bankDetails/components/bankAccountsContent";
import empty from "../../../assets/illo.png";
import {
  createLedger,
  getInvoiceListForDropdown,
  getOrders,
} from "../redux/adminOrdersSlice";
import moment from "moment";
import { Link } from "react-router-dom";
import LocalStorage from "../../../utilities/localStorage";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { Controller, useForm } from "react-hook-form";
import { LoadingButton } from "@mui/lab";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import {
  // SelectSpan,
  StyledOutlineButton,
} from "../../vendorRegistration/components/StepMain";
// import { VendorCardLabel } from "./adminOrdersViewContent";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Super } from "../../vendorRegistration/components/steps/cardTrial";
import { message } from "antd";

const EmptyContainer = ({ role }) => (
  <Grid
    container
    spacing={0}
    direction="column"
    alignItems="center"
    justifyContent="center"
  >
    <br />
    <img src={empty} alt="empty" />
    <DisplayText> There are no orders to display</DisplayText>
    {/* <br /> */}
    {/* {role === "Admin" || role === "finance" ? (
      ""
    ) : (
      <ButtonLink to="/app/orders">+ Add Orders</ButtonLink>
    )} */}

    <br />
    <br />
  </Grid>
);

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };
  return (
    <>
      <Box sx={{ flexShrink: 0 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    </>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const Input = styled("input")({
  display: "none",
});
function AdminOrdersTableContent() {
  const {
    ordersList,
    loading: ordersListLoading,
    invoiceDropdownLoading,
    createLedgerLoading,
    invoiceDropdown,
  } = useSelector((state) => state.adminOrders);
  const dispatch = useDispatch();
  const role = LocalStorage.getItem("tata_login_user").roles;
  // const { pending } = useSelector((state) => state.pendinglist);
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState("");
  const [document, setDocument] = React.useState("");

  const [deduction, setDeduction] = React.useState(false);

  const {
    register,
    handleSubmit,
    // setError,
    // clearErrors,
    setValue,
    watch,
    reset,
    control,
    formState: { errors },
  } = useForm();

  const columns = [
    { id: "order_number", label: "PO Number" },
    { id: "order_type", label: "PO Type" },
    {
      id: "order_date",
      label: "PO Date",
      format: (value) => moment(value).format("DD-MM-YYYY"),
    },
    { id: "total_value", label: "PO Total Value" },
    // {
    //   id: "status",
    //   label: "Status",
    //   format: (value) => (
    //     <Chip
    //       label={value?.toUpperCase() || "Not Applicable"}
    //       color={value === "Pending" ? "warning" : "success"}
    //       size="small"
    //       style={{ fontSize: "9px" }}
    //     />
    //   ),
    // },
  ];
  const paymentOptions = [
    { label: "Advance", value: "advance" },
    { label: "Partial", value: "partial" },
    { label: "Full", value: "full" },
  ];
  const orders = () => {
    const payload = {
      rowsPerPage,
      page,
      search: "",
    };
    dispatch(getOrders(payload));
  };

  useEffect(() => {
    orders();
    // eslint-disable-next-line
  }, [page, rowsPerPage]);

  // Avoid a layout jump when reaching the last page with empty rows.
  // const emptyRows =
  //   page > 0 ? Math.max(0, (1 + page) * rowsPerPage - pending.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleOpen = (row) => {
    setSelectedRow(row);
    setOpenDialog(true);
    dispatch(getInvoiceListForDropdown(row.id));
  };
  const handleClose = () => {
    setOpenDialog(false);
    setDocument("");
    setSelectedRow("");
    reset();
    setValue("invoice_amount", null);
    setDeduction(false);
    setValue("invoice_number", null)
    setValue("payment_type", null)
    setValue("payment_date", null)
    setValue("amount", null)
    setValue("penalty", null)
    setValue("tax", null)
    setValue("tds", null)
    setValue("discrepancy", null)
    setValue("remarks", null)
  };
  const onSubmit = (data) => {
    const payload = {
      invoice_number: data?.Invoice_Number?.value,
      order_number: data?.PurchaseOrderNo,
      payment_type: data?.payment_type?.value,
      payment_date: data?.payment_date,
      amount: data?.amount,
      is_deduction: deduction,
      penalty: data?.penalty || 0,
      tax: data?.tax || 0,
      tds: data?.tds || 0,
      discrepancy: data?.discrepancy || 0,
      remark: data?.remarks,
    };

    const formData = new FormData();

    formData.append("data", JSON.stringify(payload));
    formData.append("utr_document", document);

    dispatch(createLedger(formData)).then((res) => {
      if (res.payload.success) {
        setDocument("");
        setOpenDialog(false);
        reset();
      } else {
        message.error(res.payload.message);
      }
    });
  };

  return (
    <>
      <Dialog
        open={openDialog}
        onClose={handleClose}
        aria-labelledby="draggable-dialog-title"
        PaperProps={{
          style: {
            width: "700px",
            maxWidth: "90%",
          },
        }}
      >
        <DialogTitle style={{ fontWeight: "Bold" }}>Ledger Form</DialogTitle>
        <DialogContent>
          {invoiceDropdownLoading ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <DialogContentText>
              <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={6}>
                    <DialogContentText>PO Number</DialogContentText>
                    <TextField
                      fullWidth
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      value={selectedRow?.order_number}
                      variant="standard"
                      name="PurchaseOrderNo"
                      {...register("PurchaseOrderNo", {
                        value: selectedRow?.order_number,
                      })}
                      disabled
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <DialogContentText>Invoice Number</DialogContentText>
                    <Controller
                      name="Invoice_Number"
                      control={control}
                      rules={{ required: "Please select an Invoice" }}
                      render={({ field, fieldState: { error } }) => (
                        <Autocomplete
                          {...field}
                          options={
                            invoiceDropdown?.map((it) => ({
                              value: it?.invoice_number,
                              invoice_amount: it?.invoice_amount,
                            })) || []
                          }
                          getOptionLabel={(option) => option.value || ""}
                          onChange={(event, value) => {
                            field.onChange(value);

                            const invoiceAmount = value
                              ? value.invoice_amount
                              : null;

                            setSelectedRow((prev) => ({
                              ...prev,
                              invoice_amount: invoiceAmount,
                            }));
                            setValue("invoice_amount", invoiceAmount);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="standard"
                              error={!!error}
                              helperText={error ? error.message : null}
                              placeholder="Select Invoice"
                              sx={{
                                input: {
                                  fontSize: "14px",
                                  fontFamily: "var(--font-family-reg)",
                                },
                                marginTop: 0,
                              }}
                            />
                          )}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <br />

                <DialogContentText
                  sx={{ display: "flex", alignItems: "center", gap: 2 }}
                >
                  <span>
                    UTR Document<Super>*</Super>
                  </span>
                  {document !== "" ? (
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <Chip
                        style={{
                          width: "150px",
                          color: "#4945FF",
                          borderRadius: "5px",
                          border: "1px solid #D9D8FF",
                          background: "#F0F0FF",
                        }}
                        label={document.name}
                        value={document.name}
                        name="chips"
                      />
                      <HighlightOffIcon
                        sx={{ color: "#4945FF", cursor: "pointer" }}
                        fontSize="medium"
                        onClick={() => setDocument("")}
                      />
                    </span>
                  ) : (
                    <label
                      htmlFor="leisureDocument"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <Input
                        {...register("leisureDocument", {
                          required: "Please upload Leisure Document",
                        })}
                        accept="*"
                        id="leisureDocument"
                        onChange={(e) => setDocument(e.target.files[0])}
                        type="file"
                        style={{ display: "none" }}
                      />
                      <StyledOutlineButton variant="outlined" component="span">
                        Upload
                      </StyledOutlineButton>
                    </label>
                  )}
                </DialogContentText>
                {document === "" && (
                  <FormHelperText error>
                    {errors.leisureDocument?.message}
                  </FormHelperText>
                )}
                <br />

                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={6}>
                    <DialogContentText>Invoice Amount</DialogContentText>
                    <TextField
                      style={{ width: "100%" }}
                      type="number"
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      placeholder="Enter Invoice Amount"
                      variant="standard"
                      disabled
                      name="invoice_amount"
                      value={watch("invoice_amount") || ""}
                      {...register("invoice_amount")}
                      error={Boolean(errors?.invoice_amount)}
                      helperText={errors.invoice_amount?.message}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">₹</InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <DialogContentText> Amount</DialogContentText>
                    <TextField
                      style={{ width: "100%" }}
                      type="text"
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      placeholder="Enter Amount"
                      variant="standard"
                      name="amount"
                      {...register("amount", {
                        required: "Please Enter Amount",
                        pattern: {
                          value: /^\d+(\.\d{1,2})?$/,
                          message: "Please enter a valid number",
                        },
                      })}
                      error={Boolean(errors?.amount)}
                      helperText={errors.amount?.message}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">₹</InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item md={6}>
                    <FormControl variant="standard" style={{ width: "100%" }}>
                      <DialogContentText>
                        Payment Date<Super>*</Super>
                      </DialogContentText>

                      <TextField
                        sx={{
                          input: {
                            fontSize: "14px",
                            fontFamily: "var(--font-family-reg)",
                          },
                        }}
                        InputProps={{
                          disableUnderline: false,
                          disableInjectingGlobalStyles: true,
                        }}
                        InputLabelProps={{
                          disableAnimation: true,
                          disableInjectingGlobalStyles: true,
                        }}
                        size="small"
                        variant="standard"
                        type="date"
                        style={{
                          borderBottom: errors?.payment_date
                            ? "0"
                            : "1px solid lightgray",
                        }}
                        name="payment_date"
                        placeholder="Select Payment Date"
                        {...register("payment_date", {
                          required: "Please Select Payment Date",
                        })}
                        error={Boolean(errors?.payment_date)}
                        helperText={errors?.payment_date?.message}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={6}>
                    <DialogContentText>Payment Type</DialogContentText>
                    <Controller
                      name="payment_type"
                      control={control}
                      rules={{ required: "Please Select Payment Type" }}
                      render={({ field, fieldState: { error } }) => (
                        <>
                          <Autocomplete
                            {...field}
                            options={paymentOptions || []}
                            fullWidth
                            onChange={(_, value) => field.onChange(value)}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="standard"
                                error={!!error}
                                helperText={error ? error.message : null}
                                sx={{
                                  input: {
                                    fontSize: "14px",
                                    fontFamily: "var(--font-family-reg)",
                                  },
                                  marginTop: 0,
                                }}
                              />
                            )}
                          />
                        </>
                      )}
                    />
                  </Grid>
                </Grid>

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={deduction}
                      onChange={(e) => setDeduction(e.target.checked)}
                    />
                  }
                  label="Deduction"
                  sx={{ marginTop: "15px" }}
                />
                {deduction && (
                  <>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={6}>
                        <DialogContentText>Penalty</DialogContentText>
                        <TextField
                          fullWidth
                          type="text"
                          placeholder="Enter Penalty"
                          variant="standard"
                          {...register("penalty", {
                            required: "Please Enter Penalty",
                            min: {
                              value: 0,
                              message: "Value must be at least 0",
                            },
                            pattern: {
                              value: /^\d+(\.\d{1,2})?$/,
                              message: "Please enter a valid number",
                            },
                          })}
                          error={Boolean(errors?.penalty)}
                          helperText={errors?.penalty?.message}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                ₹
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <DialogContentText>TDS</DialogContentText>
                        <TextField
                          fullWidth
                          type="text"
                          placeholder="Enter TDS"
                          variant="standard"
                          {...register("tds", {
                            required: "Please Enter TDS",
                            min: {
                              value: 0,
                              message: "Value must be at least 0",
                            },
                            pattern: {
                              value: /^\d+(\.\d{1,2})?$/,
                              message: "Please enter a valid number",
                            },
                          })}
                          error={Boolean(errors?.tds)}
                          helperText={errors?.tds?.message}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                ₹
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <DialogContentText>Tax</DialogContentText>
                        <TextField
                          fullWidth
                          type="text"
                          placeholder="Enter Tax"
                          variant="standard"
                          {...register("tax", {
                            required: "Please Enter Tax",
                            min: {
                              value: 0,
                              message: "Value must be at least 0",
                            },
                            pattern: {
                              value: /^\d+(\.\d{1,2})?$/,
                              message: "Please enter a valid number",
                            },
                          })}
                          error={Boolean(errors?.tax)}
                          helperText={errors?.tax?.message}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                ₹
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <DialogContentText>Discrepancy</DialogContentText>
                        <TextField
                          fullWidth
                          type="text"
                          placeholder="Enter Discrepancy"
                          variant="standard"
                          {...register("discrepancy", {
                            required: "Please Enter Discrepancy",
                            min: {
                              value: 0,
                              message: "Value must be at least 0",
                            },
                            pattern: {
                              value: /^\d+(\.\d{1,2})?$/,
                              message: "Please enter a valid number",
                            },
                          })}
                          error={Boolean(errors?.discrepancy)}
                          helperText={errors?.discrepancy?.message}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                ₹
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                    </Grid>
                  </>
                )}

                <Grid item xs={12} sx={{ marginTop: "9px" }}>
                  <DialogContentText>Remarks</DialogContentText>
                  <Grid item md={12}>
                    {/* <VendorCardLabel>
                             Remarks<Super>*</Super>
                             </VendorCardLabel> */}
                    <TextField
                      multiline
                      rows={3}
                      style={{
                        width: "100%",
                        paddingTop: "3px",
                        fontSize: "14px",
                        fontFamily: "var(--font-family-reg)",
                      }}
                      placeholder={`Enter Remarks`}
                      size="small"
                      name="remarks"
                      {...register("remarks")}
                      error={Boolean(errors?.remarks)}
                      helperText={errors?.remarks?.message}
                    />
                  </Grid>
                </Grid>
                <Grid
                  sx={{
                    display: "flex",
                    gap: "1rem",
                    justifyContent: "end",
                    alignItems: "center",
                    marginTop: "2rem",
                  }}
                >
                  <Button
                    autoFocus
                    onClick={handleClose}
                    style={{ height: "40px", border: "#4059e5 solid 1px" }}
                  >
                    Cancel
                  </Button>
                  <LoadingButton
                    sx={{
                      textTransform: "none",
                      background: "#4059e5",
                      width: "200px",
                      height: "40px",
                    }}
                    color="primary"
                    variant="contained"
                    type="submit"
                    loading={createLedgerLoading}
                    loadingPosition="start"
                  >
                    Submit
                  </LoadingButton>
                </Grid>
              </form>
            </DialogContentText>
          )}
        </DialogContent>
      </Dialog>
      {ordersListLoading ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <CustomTableContainer component={Card}>
          <Table aria-label="dynamic table">
            <CustomTableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell key={column.id} align="left">
                    <TableHeaderFont>{column.label}</TableHeaderFont>
                  </TableCell>
                ))}
                <TableCell align="center">
                  <TableHeaderFont>Action</TableHeaderFont>
                </TableCell>
              </TableRow>
            </CustomTableHead>
            {ordersList?.data?.length !== 0 ? (
              <TableBody>
                {ordersList?.data?.map((row) => (
                  <TableRow key={row.id}>
                    {columns.map((column) => (
                      <TableCell key={column.id}>
                        <TableContentFont
                          style={{
                            color:
                              column.id === "order_number" ? "#4945ff" : "none",
                          }}
                        >
                          {column.format
                            ? column.format(row[column.id])
                            : row[column.id] || "Not Applicable"}
                        </TableContentFont>
                      </TableCell>
                    ))}
                    <TableCell align="center">
                      <Tooltip title="View Order">
                        <Link
                          to={`/app/orders-list-view/${row.id}`}
                          style={{ textDecoration: "none" }}
                        >
                          <RemoveRedEye
                            style={{
                              fill: "royalblue",
                              height: "18px",
                              width: "18px",
                            }}
                          />
                        </Link>
                      </Tooltip>
                      {row?.is_ledger_creater === true && (
                        <Tooltip title="Ledger Form">
                          <IconButton onClick={() => handleOpen(row)}>
                            <AddBoxOutlinedIcon
                              color="action"
                              fontSize="small"
                            />
                          </IconButton>
                        </Tooltip>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            ) : (
              <TableBody>
                <TableRow>
                  <TableCell colSpan={columns.length + 1}>
                    <CustomTableContainer>
                      <EmptyContainer role={role[0]} />
                    </CustomTableContainer>
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
          <Grid
            container
            className="d-flex flex-row align-items-center justify-content-between w-100 px-3 text-muted"
            sx={{ height: "10vh", borderTop: "1px solid lightgray" }}
          >
            <Grid className="d-flex align-items-center gap-2">
              <span>Rows per page: </span>
              <select
                value={rowsPerPage}
                onChange={(e) => {
                  setRowsPerPage(e.target.value);
                  setPage(1);
                }}
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
            </Grid>
            <Pagination
              sx={{
                width: "max-content",
              }}
              color="primary"
              variant="text"
              onChange={(_, newValue) => setPage(newValue)}
              count={ordersList?.pagination?.total_page}
              page={page}
              shape="rounded"
              onRowsPerPageChange={handleChangeRowsPerPage}
              showFirstButton
              showLastButton
            />
          </Grid>
        </CustomTableContainer>
      )}
    </>
  );
}

export default AdminOrdersTableContent;
